import {Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from '@angular/common';

@Pipe({
    name: 'currencyConverter'
})
export class CurrencyConverterPipe implements PipeTransform {

    private keysToConvert = [
        'ExF_excl_VAT',
        'ExF_excl_VAT_unit',
        'ExF_excl_VAT_from',
        'ExF_excl_VAT_to',
        'ExF_excl_VAT_diff',
        'WHS_excl_VAT',
        'WHS_excl_VAT_unit',
        'WHS_excl_VAT_from',
        'WHS_excl_VAT_to',
        'WHS_excl_VAT_diff',
        'Ret_excl_VAT',
        'Ret_excl_VAT_unit',
        'Ret_excl_VAT_from',
        'Ret_excl_VAT_to',
        'Ret_excl_VAT_diff',
        'Ret_incl_VAT',
        'Ret_incl_VAT_unit',
        'Ret_incl_VAT_from',
        'Ret_incl_VAT_to',
        'Ret_incl_VAT_diff',
        'ExF_net_price',
        'Tender_ExFactory_price',
        'Hospital_price',
        'Net_ExFactory_price',
        'Mandatory_discount',
        'Tender_Discount',
        'unit_price'
    ];

    private discountColumns = [
        'ExF_excl_VAT_diff',
        'WHS_excl_VAT_diff',
        'Ret_excl_VAT_diff',
        'Ret_incl_VAT_diff',
        'Mandatory_discount',
        'Tender_Discount'
    ];

    constructor(private decimal: DecimalPipe) {
    }

    transform(value: any, args?: any): any {
        if (!value) {
            return '';
        }

        if (this.keysToConvert.indexOf(args) !== -1) {
            if (this.discountColumns.indexOf(args) !== -1) {
                const formattedValue = this.formatNumberValueIfPossible(value[args]);

                return formattedValue + '%';
            } else {
                return this.formatNumberValueIfPossible(value[args]);
            }
        }

        return value[args];
    }

    private formatNumberValueIfPossible(field) {
        try {
            if (field) {
                return this.decimal.transform(field, '1.2-2');
            }
            return '0.00';
        } catch (e) {
            return '0.00';
        }
    }


}
